import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts"

const SensorGraphs = ({ devices }) => {
  // Generate mock historical data for the last 24 hours
  const generateHistoricalData = (device) => {
    const data = []
    const now = new Date()

    for (let i = 23; i >= 0; i--) {
      const time = new Date(now.getTime() - i * 60 * 60 * 1000)
      const baseChemical = device.sensors.chemical.value
      const baseVibration = device.sensors.vibration.value

      data.push({
        time: time.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
        chemical: Math.max(0, baseChemical + (Math.random() - 0.5) * 0.1),
        vibration: Math.max(0, baseVibration + (Math.random() - 0.5) * 0.2),
        chemicalThreshold: device.sensors.chemical.threshold,
        vibrationThreshold: device.sensors.vibration.threshold,
      })
    }

    return data
  }

  return (
    <div className="space-y-6">
      {devices.map((device) => {
        const data = generateHistoricalData(device)

        return (
          <div key={device.id} className="card">
            <div className="card-header">
              <h3 className="card-title">{device.name} - Sensor Data (Last 24 Hours)</h3>
            </div>

            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div>
                  <h4 className="text-md font-medium text-gray-700 mb-3">Chemical Levels (ppm)</h4>
                  <div className="h-64">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="time" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="chemical"
                          stroke="#3b82f6"
                          strokeWidth={2}
                          name="Chemical Level"
                          dot={false}
                        />
                        <Line
                          type="monotone"
                          dataKey="chemicalThreshold"
                          stroke="#ef4444"
                          strokeDasharray="5 5"
                          name="Threshold"
                          dot={false}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>

                <div>
                  <h4 className="text-md font-medium text-gray-700 mb-3">Vibration Levels (Hz)</h4>
                  <div className="h-64">
                    <ResponsiveContainer width="100%" height="100%">
                      <LineChart data={data}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="time" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line
                          type="monotone"
                          dataKey="vibration"
                          stroke="#10b981"
                          strokeWidth={2}
                          name="Vibration Level"
                          dot={false}
                        />
                        <Line
                          type="monotone"
                          dataKey="vibrationThreshold"
                          stroke="#ef4444"
                          strokeDasharray="5 5"
                          name="Threshold"
                          dot={false}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default SensorGraphs

